module.exports = __webpack_public_path__ + "static/media/DB_Heavent_v3.2.1.3657cf46.ttf";